
















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapGetters, mapState } from 'vuex'
import { Ability } from '@/types/Ability'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ExaGenericTable from '@exatech-group/generic-table/src/GenericTable.vue'
import _ from 'lodash'
import { Code, RankingGroup } from '@/types/RankingGroup'

@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA', 'user_session_id']),
        ...mapState('auth', ['user', 'authUser', 'user_session_id']),
        ...mapGetters('definitionDesBarres', [
            'tableauDesConcours',
            'meta',
            'links',
            'loading',
            'error',
            'currentPage',
            'lastPage',
            'totalPage',
            'totalRows'
        ])
    },
    components: {
        ExaGenericTable,
        FontAwesomeIcon
    }
})
export default class DefinitionDesBarres extends Vue {
    Ability = Ability

    sortBy = ''
    sortDesc = false
    sortDirection = 'asc'
    filterOn = []
    stickyHeader = true
    filtres: any = []
    dataForTab: Array<any> = []
    ranking_groups: Array<RankingGroup> = []

    genericfields = [
        { key: 'phase.name', label: 'Phase', sortable: true, class: '', type: 'text' },
        { key: 'concour.name', label: 'Concours', sortable: true, class: '', type: 'text' },
        { key: 'concour.banque.name', label: 'Filière', sortable: true, class: '', type: 'text' },
        {
            key: 'notes_finales_validated',
            label: 'Notes finales validées',
            sortable: true,
            class: 'text-center',
            type: 'text'
        },
        {
            key: 'barres',
            label: 'Définition des barres',
            sortable: true,
            class: 'text-center',
            type: 'text'
        },
        {
            key: 'barre_principale',
            label: 'Barre principale',
            sortable: true,
            class: 'text-center',
            type: 'text'
        },
        {
            key: 'barre_secondaire',
            label: 'Barre secondaire',
            sortable: true,
            class: 'text-center',
            type: 'text'
        },
        { key: 'candidats', label: 'Candidats inscrits', sortable: true, class: 'text-center', type: 'text' },
        { key: 'candidats_recus', label: 'Non éliminés', sortable: true, class: 'text-center', type: 'text' },
        { key: 'link', label: '', sortable: false, class: '', type: 'text' }
    ]

    params = null
    exportingIsWorking = false

    @Watch('user_session_id')
    refreshInterface() {
        this.load()
    }

    @Watch('tableauDesConcours')
    getTableauConcours() {
        this.setDataForGenericTab(this.$store.getters['definitionDesBarres/tableauDesConcours'])
    }

    // Création des lignes du tableau
    setDataForGenericTab(poData: any, isLoadMore = false) {
        if (!isLoadMore) {
            this.dataForTab = []
        }
        if (poData) {
            for (const result of poData) {
                let barre = result?.deliberation?.barres
                if (barre.length) {
                    barre = barre.filter((barre: any) => {
                        return this.ranking_groups.find((rankingGroup: any) => {
                            return barre.ranking_group_id === rankingGroup.id
                        })
                    })[0]
                }

                const phase = result?.phase?.name || '-'
                const concour = result?.concour?.name || '-'
                const filiere = result?.concour?.banque?.name || '-'
                const notesFinalesValidees = this.getPuceColorNotesFinales(result)
                const definitionDesBarres = this.getPuceColorDefinitionDesBarres(result, barre)
                const barrePrincipale = barre?.thresholds[0]?.value || '-'
                const barreSecondaire = barre?.thresholds[1]?.value || '-'
                const candidatsInscrits = result && result.candidats_count ? result.candidats_count : '-'
                const candidatsRecus = result && result.candidats_recus_count ? result.candidats_recus_count : '-'
                const link = [
                    {
                        name: 'arrow-circle-right',
                        class: result.ajustements_validated_at ? 'text-info' : 'text-secondary',
                        id: result.id,
                        barre: result
                    }
                ]
                const line = [
                    { label: '', item: phase, type: 'text', typeAction: null, class: '' },
                    { label: '', item: concour, type: 'text', typeAction: null, class: '' },
                    { label: '', item: filiere, type: 'text', typeAction: null, class: '' },
                    {
                        label: '',
                        item: notesFinalesValidees,
                        type: 'icons',
                        typeAction: null,
                        class: 'text-center'
                    },
                    {
                        label: definitionDesBarres[0].title,
                        item: definitionDesBarres,
                        type: 'icons',
                        typeAction: null,
                        class: 'text-center'
                    },
                    {
                        label: '',
                        item: barrePrincipale,
                        type: 'text',
                        typeAction: null,
                        class: 'text-center'
                    },
                    {
                        label: '',
                        item: barreSecondaire,
                        type: 'text',
                        typeAction: null,
                        class: 'text-center'
                    },
                    {
                        label: '',
                        item: candidatsInscrits,
                        type: 'text',
                        typeAction: null,
                        class: 'text-center'
                    },
                    {
                        label: '',
                        item: candidatsRecus,
                        type: 'text',
                        typeAction: null,
                        class: 'text-center'
                    },
                    {
                        label: 'Ouvrir',
                        item: link,
                        type: 'icons',
                        typeAction: result.ajustements_validated_at ? 'link' : null,
                        class: 'text-center'
                    }
                ]
                this.dataForTab.push(line)
            }
        }
    }

    // Création des filtres
    setFiltersForGenericTab() {
        const deroulant_banques = _.orderBy(
            this.$store.getters['banque/banques'].map((banque: any) => {
                return { index: banque.id, name: banque.name }
            }), 'name', 'asc')

        const concours = this.$store.getters['concour/concours']
        const deroulant_concours = _.orderBy(
            concours.map((concour: any) => {
                return { index: concour.name, name: concour.name }
            }), 'name', 'asc')
        const deroulant_phases = concours[0].phases.map((phase: any) => {
            return { index: phase.name, name: phase.name }
        })

        const deroulant_bool = [
            { index: 1, name: 'Oui' },
            { index: 0, name: 'Non' }
        ]

        this.filtres = [
            {
                libelle: 'Phase',
                defautOptionlibelle: 'Rechercher une',
                model: 'phase.name',
                value: '',
                index: 'phase.name',
                datas: deroulant_phases,
                loading: this.$store.getters['definitionDesBarres/loading'],
                options: { type: 'deroulant', fieldsKey: 'phase.name', strict: true }
            },
            {
                libelle: 'Concours',
                defautOptionlibelle: 'Rechercher un',
                model: 'concour.name',
                value: '',
                index: 'concour.name',
                datas: deroulant_concours,
                loading: this.$store.getters['definitionDesBarres/loading'],
                options: { type: 'deroulant', fieldsKey: 'concour.name', strict: true }
            },
            {
                libelle: 'Filière',
                defautOptionlibelle: 'Rechercher une',
                model: 'concour.banque.id',
                value: '',
                index: 'concour.banque.id',
                datas: deroulant_banques,
                loading: this.$store.getters['definitionDesBarres/loading'],
                options: { type: 'deroulant', fieldsKey: 'concour.banque.name', strict: true }
            },
            {
                libelle: 'Notes finale validées',
                defautOptionlibelle: 'Rechercher une',
                model: 'notes_finales_validated',
                value: '',
                index: 'notes_finales_validated',
                datas: deroulant_bool,
                loading: this.$store.getters['definitionDesBarres/loading'],
                options: { type: 'deroulant', fieldsKey: 'notes_finales_validated', strict: true }
            },
            {
                libelle: 'Définition des barres',
                defautOptionlibelle: 'Rechercher une',
                model: 'barres',
                value: '',
                index: 'barres',
                datas: deroulant_bool,
                loading: this.$store.getters['definitionDesBarres/loading'],
                options: { type: 'deroulant', fieldsKey: 'barres', strict: true }
            }
        ]
    }

    // Events du tableau
    handleTableEvent(paParams: any): void {
        if (paParams && paParams[0] && paParams[1]) {
            let id
            if (paParams[1][0]) {
                id = paParams[1][0].id
            }

            switch (paParams[0]) {
                case 'sortHandler':
                    this.filtreSortHandler(paParams[1])
                    break

                case 'filterHandler':
                    this.filtreSortHandler(paParams[1])
                    break

                case 'onLoadPage':
                    this.loadHandler(paParams[1])
                    break

                case 'link':
                    this.$store.commit('definitionBarresStatistiquesEpreuves/RESET_STATE')
                    this.$store.commit('definitionBarresAnalysesHypotheses/RESET_STATE')
                    this.$store.commit('definitionBarresStatistiquesConcours/RESET_STATE')
                    this.$store.commit('definitionDesBarres/SET_SELECTED_CONCOUR', paParams[1][0].barre)

                    if (paParams[1][0].barre.phase.name === 'Admissibilité') {
                        this.$store.dispatch('definitionBarresListeNotes/RESET_LISTE_NOTES')
                        this.$router.push(`/definition_des_barres/${id}`)
                    } else if (paParams[1][0].barre.phase.name === 'Admission') {
                        this.$store.dispatch('definitionBarresListeNotesAdmission/RESET_LISTE_NOTES')
                        this.$router.push(`/definition_des_barres_admission/${id}`)
                    }
                    break

                default:
                    break
            }
        }
    }

    // Chargement des résultats
    loadHandler(params: any) {
        if (JSON.stringify(this.params) !== JSON.stringify(params)) {
            this.params = params
            this.$store
                .dispatch('definitionDesBarres/getMoreTableauDesConcours', params)
                .then(() => {
                    this.setDataForGenericTab(this.$store.getters['definitionDesBarres/tableauDesConcours'])
                })
                .catch((error) => {
                    console.log('ko:' + error)
                })
        }
    }

    // Applique les filtres
    filtreSortHandler(params: any) {
        if (JSON.stringify(this.params) !== JSON.stringify(params)) {
            this.params = params
            this.$store.dispatch('definitionDesBarres/getTableauDesConcours', params)
                .then(() => {
                    this.setDataForGenericTab(this.$store.getters['definitionDesBarres/tableauDesConcours'])
                })
                .catch((error) => {
                    console.log('ko:' + error)
                })
        }
    }

    // Creation des puces pour les notes finales validées
    getPuceColorNotesFinales(result: any) {
        const class_affichage = result?.ajustements_validated_at ? 'text-success' : 'text-tertiary'
        return [{ name: 'circle', class: class_affichage }]
    }

    // Creation des puces pour definition des barres
    getPuceColorDefinitionDesBarres(result: any, barre: any) {
        let class_affichage = 'text-tertiary'
        let title_affichage = 'Barre(s) non définie(s)'
        if (result?.deliberation?.barreValide) {
            class_affichage = 'text-success'
            title_affichage = 'Barre(s) validée(s)'
        } else if (barre?.thresholds[0]?.value) {
            class_affichage = 'text-info'
            title_affichage = 'Barre(s) en cours de définition'
        }
        return [{ name: 'circle', class: class_affichage, title: title_affichage }]
    }

    // TODO: Export
    // -> Câbler l'export
    exporter () {
        console.log('exporter')
    }

    async load() {
        await this.$store.dispatch('concour/getConcours', { perPage: 0 })
        await this.$store.dispatch('banque/getBanques', { perPage: 0 })

        if (!this.$store.getters['rankingGroup/rankingGroups'].length) {
            await this.$store.dispatch('rankingGroup/getRankingGroups')
        }
        this.ranking_groups = this.$store.getters['rankingGroup/rankingGroups']
            .map((rankingGroup: RankingGroup) => {
                return { id: rankingGroup.id, code: rankingGroup.code }
            })
            .filter((rankingGroup: RankingGroup) => {
                return rankingGroup.code === Code.CODE_ADMISSIBLE || rankingGroup.code === Code.CODE_ADMIS
            })

        await this.$store.dispatch('definitionDesBarres/getTableauDesConcours')
        await this.$store.dispatch('definitionBarresListeNotes/RESET_LISTE_NOTES')
        await this.$store.dispatch('definitionBarresListeNotesAdmission/RESET_LISTE_NOTES')
        this.$store.commit('definitionBarresStatistiquesEpreuves/RESET_STATE')
        this.$store.commit('definitionBarresAnalysesHypotheses/RESET_STATE')
        this.$store.commit('definitionBarresStatistiquesConcours/RESET_STATE')
    }

    async mounted() {
        if (this.$store.getters['auth/user_session_id'] !== null) {
            await this.load()
            this.setFiltersForGenericTab()
        }
    }
}
